import styled from 'styled-components';

export const DashboardContainer = styled.div`
  width: 100%;
`;

export const DashboardContent = styled.div`
  background-color: ${({ theme }) => theme.lightGrayColor};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 24px;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  text-align: center;
  color: ${({ theme }) => theme.textColor};

  p {
    margin: 8px 0;

    &:first-child {
      font-size: 18px;
      font-weight: 500;
    }
  }
`;
